const OrgType = {
  NonProfit: 'npo',
  Business: 'business',
  ChangeMakers: 'change-makers',
};

export default OrgType;
